// snackbarEmitter.ts
type Severity = "success" | "error" | "warning" | "info"

type ShowSnackbar = (params: { message: string; severity?: Severity }) => void

let _showSnackbar: ShowSnackbar | null = null

export const setSnackbarEmitter = (fn: ShowSnackbar) => {
    _showSnackbar = fn
}

export const emitSnackbar = (params: { message: string; severity?: Severity }) => {
    _showSnackbar?.(params)
}